import { __rest } from "tslib";
import { get, set } from 'lodash-es';
import { clone } from './data';
export var JSONSchemaType;
(function (JSONSchemaType) {
    JSONSchemaType["array"] = "array";
    JSONSchemaType["boolean"] = "boolean";
    JSONSchemaType["string"] = "string";
    JSONSchemaType["number"] = "number";
    JSONSchemaType["integer"] = "integer";
    JSONSchemaType["object"] = "object";
    JSONSchemaType["null"] = "null";
})(JSONSchemaType || (JSONSchemaType = {}));
export function deRef(schema) {
    const newSchema = clone(schema);
    const deRefedPaths = {};
    const recursivelyDeRef = (subSchema, path = '') => {
        if (Array.isArray(subSchema)) {
            // loop through all elements to deRef them
            subSchema.forEach((subSubSchema, index) => recursivelyDeRef(subSubSchema, `${path}[${index}]`));
        }
        else if (deRefedPaths[subSchema === null || subSchema === void 0 ? void 0 : subSchema.$ref]) {
            // if a ref is already deRefed, use the deRefed version
            set(newSchema, path, deRefedPaths[subSchema === null || subSchema === void 0 ? void 0 : subSchema.$ref]);
        }
        else if (subSchema && typeof subSchema === 'object') {
            // if object has $ref, replace it with the referenced schema
            if (subSchema.$ref) {
                const { $ref } = subSchema, restProperties = __rest(subSchema, ["$ref"]);
                const ref = $ref.split('#')[1];
                const refParts = ref.split('/');
                const refPath = refParts.reduce((acc, part) => (acc ? `${acc}['${part}']` : part), '');
                subSchema = Object.assign(Object.assign({}, clone(get(schema, refPath))), restProperties);
                set(newSchema, path, subSchema);
                deRefedPaths[$ref] = subSchema;
            }
            // loop through all properties to deRef them
            Object.entries(subSchema).forEach(([key, subSubSchema]) => recursivelyDeRef(subSubSchema, `${path}['${key}']`));
        }
    };
    recursivelyDeRef(newSchema);
    return newSchema;
}
export function getDefaultJsonFromSchema(schema) {
    // if default is defined return that or else form default
    if (schema.default !== undefined)
        return schema.default;
    switch (schema.type) {
        case 'string':
            return '';
        case 'number':
        case 'integer':
            return undefined;
        case 'boolean':
            return null;
        case 'array':
            return [];
        case 'object': {
            const { properties = {} } = schema;
            const defaultObj = {};
            Object.keys(properties).forEach((key) => {
                defaultObj[key] = getDefaultJsonFromSchema(properties[key]);
            });
            return defaultObj;
        }
        default:
            return null;
    }
}
export function isSchemaObjectType(schema) {
    return schema.type === JSONSchemaType.object;
}
export function isSchemaArrayType(schema) {
    return schema.type === JSONSchemaType.array;
}
export function isSchemaMapType(schema) {
    return Boolean(schema.type === JSONSchemaType.object &&
        !schema.properties &&
        schema.additionalProperties &&
        schema.additionalProperties.type);
}
